webpackJsonp([40],{

/***/ "+K7v":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+S4w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "02pT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0tE7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_scroll_vue__ = __webpack_require__("bDtG");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_284a1b76_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_scroll_vue__ = __webpack_require__("2aSK");
function injectStyle (ssrContext) {
  __webpack_require__("dPNW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-284a1b76"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_scroll_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_284a1b76_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_scroll_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "17Mt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_tab_item_vue__ = __webpack_require__("uZYF");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_8f3c6a26_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_tab_item_vue__ = __webpack_require__("Yd+V");
function injectStyle (ssrContext) {
  __webpack_require__("9imS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_tab_item_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_8f3c6a26_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_tab_item_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "1EBJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1H7Z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "22O3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = __webpack_require__("pFYg");

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  setStorage: setStorage,
  getStorage: getStorage,
  removeStorage: removeStorage
};

var ls = window.localStorage;
var ss = window.sessionStorage;
function setStorage(key, value, flag) {
  if (arguments.length > 1) {
    var v = value;
    if ((typeof v === 'undefined' ? 'undefined' : (0, _typeof3.default)(v)) === 'object') {
      v = (0, _stringify2.default)(v);
      v = 'obj-' + v;
    } else {
      v = 'str-' + v;
    }
    if (ls && ss) {
      if (flag) {
        ls.setItem(key, v);
      } else {
        ss.setItem(key, v);
      }
    }
  }
}

function getStorage(key, flag) {
  // if (ls) {
  var v = '';
  if (flag) {
    v = ls.getItem(key);
  } else {
    v = ss.getItem(key);
  }
  if (!v) {
    return;
  }
  if (v.indexOf('obj-') > -1) {
    v = v.slice(4);
    return JSON.parse(v);
  } else if (v.indexOf('str-') > -1) {
    return v.slice(4);
  } else {
    return v;
  }
  // }
}

function removeStorage(key, flag) {
  if (flag) {
    window.localStorage.removeItem(key);
  } else {
    window.sessionStorage.removeItem(key);
  }
}

/***/ }),

/***/ "2Uyi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _book = __webpack_require__("aK6G");

var api = _interopRequireWildcard(_book);

var _user = __webpack_require__("vMJZ");

var user = _interopRequireWildcard(_user);

var _storage = __webpack_require__("22O3");

var _storage2 = _interopRequireDefault(_storage);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isDev = false;
var Gprefix = '';
var Gtype = 'h5';
var GRoot = '';
var GV = 'v1'; // 全局ajax接口的版本控制，值为'v1' or 'v2'
var GVer = 'read';
var initUrl = 'common/init';
var GRegTel = /^1[3-9]\d{9}$/;
var GRegEmail = /^\w+@\w+[.]\w{2,3}$/;
// 环境配置
var istest = getQuery('istest');
var currhost = window.location.host;
var testHosts = ['h5.test.sheep.qingyin.net:9888', 'h5.test.better.qingyin.net'];
if (istest || testHosts.indexOf(currhost) > -1) {
	isDev = true;
}
if (isDev) {
	Gprefix = 'https://better.test.qingyin.net/server/better/api';
} else {
	Gprefix = 'https://better.qingyin.net/server/better/api';
}
GRoot = 'http://' + window.location.host + '/';
exports.default = {
	BDClickTj: BDClickTj,
	BDPvTj: BDPvTj,
	phoneStar: phoneStar,
	initUrl: initUrl,
	GRegTel: GRegTel,
	GRegEmail: GRegEmail,
	apihost: Gprefix,
	Gtype: Gtype,
	Root: GRoot,
	GV: GV,
	GVer: GVer,
	getQuery: getQuery,
	URLProxy: URLProxy,
	ckLogin: ckLogin,
	goRouter: goRouter,
	goPay: goPay,
	listModel: listModel,
	examTime: examTime,
	initMinuter: initMinuter,
	dataFormat: dataFormat,
	getTimeText: getTimeText,
	getTimeS: getTimeS,
	blurIn: blurIn,
	ckMobile: ckMobile,
	getUserInfo: getUserInfo,
	getPackageInfo: getPackageInfo,
	goTop: goTop,
	setTitle: setTitle,
	isIOS: isIOS,
	isMobile: isMobile,
	header: ajaxHeader,
	ColorReverse: ColorReverse,
	getColorRGB: getColorRGB,
	checkColorPick: checkColorPick,
	resourceUrl: resourceUrl,
	resourceTypeText: resourceTypeText
	// 资源类型
};
function resourceTypeText(v) {
	var typeArr = {
		1: '查看专栏',
		2: '查看图书',
		3: '观看直播',
		4: '查看课程',
		5: '收听夜谈',
		6: '查看会员',
		7: '开始学习'
	};
	return typeArr[v];
}
function resourceUrl(_this, info) {
	if (info.resource_type == 1 || info.resource_type == 2) {
		_this.$router.replace({ name: 'bookIndex' });
	} else if (info.resource_type == 4 || info.resource_type == 7) {
		if (info.resource_type == 4 && info.type == 2) {
			_this.$router.replace({ name: 'myCourse' });
		} else {
			_this.$router.replace({ name: 'chapterList', params: { rtype: info.resource_type, rpid: info.resource_id, rid: info.resource_id } });
		}
	} else if (info.resource_type == 5) {
		_this.$router.replace({ name: 'radioIndex', params: { resource_type: info.resource_type, resource_id: info.resource_id } });
	} else {
		_this.$router.replace({ name: 'mine' });
	}
}
// 判断颜色是否接近于白色
function getColorRGB(sColor, opacity) {
	if (sColor) {
		sColor = sColor.toLowerCase();
	}
	// 十六进制颜色值的正则表达式
	var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
	// 如果是16进制颜色
	if (sColor && reg.test(sColor)) {
		if (sColor.length === 4) {
			var sColorNew = '#';
			for (var j = 1; j < 4; j++) {
				sColorNew += sColor.slice(j, j + 1).concat(sColor.slice(j, j + 1));
			}
			sColor = sColorNew;
		}
		// 处理六位的颜色值
		var sColorChange = [];
		for (var i = 1; i < 7; i += 2) {
			sColorChange.push(parseInt('0x' + sColor.slice(i, i + 2)));
		}
		if (opacity) {
			sColorChange.push(opacity);
			return 'rgba(' + sColorChange.join(',') + ')';
		} else {
			return 'rgb(' + sColorChange.join(',') + ')';
		}
	}
	return sColor;
}
function checkColorPick(val) {
	var checkarr = val;
	if (checkarr[0] >= 200 && checkarr[1] >= 200 && checkarr[2] >= 200) {
		return false;
	} else {
		return val;
	}
}
// 去颜色的反色
function ColorReverse(v) {
	var OldColorValue = '0x' + v.replace(/#/g, '');
	var str = '000000' + (0xFFFFFF - OldColorValue).toString(16);
	return '#' + str.substring(str.length - 6, str.length);
}
function ajaxHeader() {
	var v = { 'Content-Type': 'application/x-www-form-urlencoded' };
	return v;
}
function BDClickTj(v) {
	console.log('##### BDClickTj v = ' + (0, _stringify2.default)(v));
	window._hmt.push(['_trackEvent', v.type, v.action, v.tag]);
}
function BDPvTj(v) {
	console.log('##### BDPvTj v = ' + GRoot + v);
	window._hmt.push(['_trackPageview', GRoot + v]);
}
// *手机号
function phoneStar(p) {
	var reg = /^(.{3}).*(.{4})$/;
	var val = p.replace(reg, '$1****$2');
	return val;
}
// 获取地址栏参数
function getQuery(name) {
	var reg = new RegExp('(^|&|[?])' + name + '=([^&]*)(&|$)');
	var r = window.location.search.substr(1).match(reg);
	return r != null ? r[2] : '';
}
// 接口路径
function URLProxy(uri, vFlag) {
	// 有版本号
	if (vFlag) {
		uri = GV + '/' + uri;
	}
	var vnum = GV;
	if (vnum !== 'v1') {
		uri = uri.replace('v1.', vnum + '.');
	}
	var url = Gprefix + '/' + Gtype + '/' + uri;
	return url;
}
// 微信授权
function getWxAuth(link, params) {
	var url = '';
	var opt = params || {};
	var scopes = opt.scopes || 0;
	var href = link || window.location.href;
	var backUrl = encodeURIComponent(href);
	var wx = opt.wx || 0;
	var cur1 = encodeURIComponent(Gprefix + '/login?back=' + backUrl);
	url = 'https://oauth.qingyin.net/api/wx/oauth/a?scopes=' + scopes + '&curl=' + cur1 + '&wx=' + wx;
	window.location.replace(url);
}
// 去授权
function goAuth(scopes) {
	getWxAuth(window.location.href, { scopes: scopes, wx: 2 });
}
// 检查是否登录
function ckLogin(v) {
	if (!v) {
		goAuth(1);
	}
}
// 路由跳转
function goRouter(_this, name, v, flag) {
	if (flag) {
		_this.$router.replace({ name: 'index' });
	} else {
		_this.$router.push({ name: name, query: v });
	}
}
// 去购买
function goPay(notifyUrl, rtype, rid, cdc) {
	var url;
	if (cdc) {
		url = Gprefix + '/' + Gtype + '/' + GV + '/pay/weixin?notify_url=' + encodeURIComponent(notifyUrl) + '&resource_type=' + rtype + '&resource_id=' + rid + '&cdc=' + cdc;
	} else {
		url = Gprefix + '/' + Gtype + '/' + GV + '/pay/weixin?notify_url=' + encodeURIComponent(notifyUrl) + '&resource_type=' + rtype + '&resource_id=' + rid;
	}
	window.location.replace(url);
}
// 一行n个数据
function listModel(list, n) {
	var index = 0;
	var count = n;
	var arrTemp = [];
	var experts = list;
	for (var i = 0; i < list.length; i++) {
		index = parseInt(i / count);
		if (arrTemp.length <= index) {
			arrTemp.push([]);
		}
		arrTemp[index].push(experts[i]);
	}
	return arrTemp;
}
// 考试时间校准
function examTime(stime, etime, ntime) {
	var t = stime + etime - ntime;
	return t;
}
// 时间转换
function initMinuter(t) {
	var days = parseInt(t / 60 / 60 / 24, 10); // 计算剩余的天数
	var hours = parseInt(t / 60 / 60 % 24, 10); // 计算剩余的小时
	var minutes = parseInt(t / 60 % 60, 10); // 计算剩余的分钟
	var seconds = parseInt(t % 60, 10); // 计算剩余的秒数
	var timer = '';
	if (days > 0) {
		timer += days + '天';
	}
	if (hours > 0) {
		timer += hours + '小时';
	}
	if (minutes > 0) {
		timer += minutes + '分钟';
	}
	if (seconds > 0) {
		timer += seconds + '秒';
	}
	return timer;
}
// 处理时间格式
function dataFormat(value, fmt) {
	var getDate = new Date(value);
	var o = {
		'M+': getDate.getMonth() + 1,
		'd+': getDate.getDate(),
		'h+': getDate.getHours(),
		'm+': getDate.getMinutes(),
		's+': getDate.getSeconds(),
		'q+': Math.floor((getDate.getMonth() + 3) / 3),
		'S': getDate.getMilliseconds()
	};
	if (/(y+)/.test(fmt)) {
		fmt = fmt.replace(RegExp.$1, (getDate.getFullYear() + '').substr(4 - RegExp.$1.length));
	}
	for (var k in o) {
		if (new RegExp('(' + k + ')').test(fmt)) {
			fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
		}
	}
	return fmt;
}
// 时间统一函数
function getTimeText(argument) {
	var timeS = argument;
	var todayT = '';
	var yestodayT = '';
	var timeCha = getTimeS(timeS);
	timeS = timeS.slice(-8);
	todayT = new Date().getHours() * 60 * 60 * 1000 + new Date().getMinutes() * 60 * 1000 + new Date().getSeconds() * 1000;
	yestodayT = todayT + 24 * 60 * 60 * 1000;
	if (timeCha > yestodayT) {
		var n = argument.replace(/-/g, '/').replace(/[年月]/g, '/').replace(/[日]/, '');
		return dataFormat(n, 'MM月dd日');
	}
	if (timeCha > todayT && timeCha < yestodayT) {
		return '昨天';
		// return timeS.slice(0, 2) > 12 ? '昨天 下午' + (timeS.slice(0, 2) == 12 ? 12 : timeS.slice(0, 2) - 12) + timeS.slice(2, 5) : '昨天 上午' + timeS.slice(0, 5)
	}
	if (timeCha < todayT) {
		return '今天';
		// return timeS.slice(0, 2) >= 12 ? '下午' + (timeS.slice(0, 2) == 12 ? 12 : timeS.slice(0, 2) - 12) + timeS.slice(2, 5) : '上午' + timeS.slice(0, 5)
	}
}
// 时间戳获取
function getTimeS(argument) {
	var timeS = argument;
	timeS = timeS.replace(/-/g, '/').replace(/[年月]/g, '/').replace(/[日]/, '');
	return new Date().getTime() - new Date(timeS).getTime() - 1000; // 有一秒的误差
}
// 手机软键盘收起
function blurIn(_this) {
	window.scrollTo(0, Math.max(_this.scrollHeight - 1, 0));
}
// 检查账户手机验证状态
function ckMobile(callabck) {
	user.ckMobile().then(function (res) {
		callabck && callabck(res);
	});
}
// 获取用户信息
function getUserInfo(callabck) {
	user.getUserInfo().then(function (res) {
		_storage2.default.setStorage('user', res);
		callabck && callabck(res);
	});
}
// 通过pid获取专栏购买地址
function getPackageInfo(pid, callback) {
	api.packageInfo(pid).then(function (res) {
		callback && callback(res);
	});
}
// 返回顶部
function goTop() {
	// $('body,html').animate({ scrollTop: 0 }, 500)
	$('.w-scroll').animate({ scrollTop: 0 }, 500);
}
// 设置title，解决微信改不了title的bug
function setTitle(title) {
	document.title = title;
	var userAgent = window.navigator.userAgent.toLowerCase();
	var isiOS = userAgent.indexOf('applewebkit') >= 0;
	var isWechat = userAgent.indexOf('micromessenger') >= 0;
	if (isiOS && isWechat) {
		var iframe = document.createElement('iframe');
		iframe.src = GRoot + 'favicon.ico';
		iframe.style.display = 'none';
		document.body.appendChild(iframe);
		iframe.onload = function () {
			setTimeout(function () {
				iframe.remove();
			}, 0);
		};
	}
}
// 全局判断是否IOS方法
function isIOS() {
	var u = navigator.userAgent;
	return u.indexOf('iPhone') > -1 || u.indexOf('Mac OS') > -1;
}
// 判断手机端还是PC
function isMobile() {
	var flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
	return flag;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ }),

/***/ "2aSK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"scroll",staticClass:"w-scroll",on:{"scroll":_vm.scrollBind}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3aKK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:_vm.menuFlag ? 'menu-icon show-m' : 'menu-icon hide-m',attrs:{"role":"button","aria-label":"展开主菜单"},on:{"click":_vm.menuShow}},[_c('i',{staticClass:"b-icon b-kuaijierukou",staticStyle:{"font-size":".7rem","margin-left":".1rem"}})]),_vm._v(" "),_c('div',{class:_vm.menuFlag ? 'b-menu-main hide hideA' : 'b-menu-main show showA'},[_c('div',{staticClass:"relative icon-flex"},_vm._l((_vm.menuList),function(item,index){return _c('div',{key:index,class:'center menu-main ' + item.color,attrs:{"role":"button"},on:{"click":function($event){return _vm.menuFc(item)}}},[(item.icon == 'stor' && item.val != 0)?_c('h4',{staticClass:"stor-icon"},[_vm._v(_vm._s(item.val)+"分")]):_c('i',{class:'b-icon b-' + item.icon,attrs:{"aria-label":item.explain}})])}),0),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.back != false),expression:"back != false"}],staticClass:"center menu-main green",attrs:{"role":"button","aria-label":"返回首页"},on:{"click":function($event){return _vm.goUrl('home')}}},[_c('i',{staticClass:"b-icon b-fanhuishouye-01",staticStyle:{"font-size":".65rem"}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.backTop && _vm.backTop == true),expression:"backTop && backTop == true"}],staticClass:"center menu-main orange",attrs:{"role":"button","aria-label":"返回顶部"},on:{"click":_vm.goTop}},[_c('i',{staticClass:"b-icon b-top"})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9aVN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"b-gradients",attrs:{"aria-hidden":"true"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9imS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AeCp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hover_menu_vue__ = __webpack_require__("NDvL");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66408352_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hover_menu_vue__ = __webpack_require__("3aKK");
function injectStyle (ssrContext) {
  __webpack_require__("Kcpa")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-66408352"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hover_menu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66408352_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hover_menu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "BpKH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Dod7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// import {common} from '@/assets/js/common.js'
var base = exports.base = {
  // 首页初始化
  HOME_INIT: 'home/init',
  // 获取配置
  GET_CONFIG: 'other/util/getConfig',
  // --------------------------  Better课程 start  --------------------------
  // 课程列表
  COURSE_LIST: 'course/getList',
  // 课程详情
  COURSE_INFO: 'course/info',
  // 训练营详情
  TRAINING_CAMP: 'training_camp/info',
  // 评分
  SET_MARK: 'section/setMark',
  // 用户课程
  USER_COURSE: 'course/getUserCourses',
  // 书签
  BOOK_MARK: 'section/getBookMarks',
  // 章节列表
  SECTION_LIST: 'section/getList',
  // 章节详情
  SECTION_INFO: 'section/info',
  // 章节播放地址
  SECTION_PLAY: 'course/section/play',
  // 新增、编辑日志
  EDIT_LOG: 'section/log/edit',
  // 商品详情
  GOODS_INFO: 'goods/info',
  // 获取赠送码
  GIFT_KEY: 'other/share/getGiftKey',
  // 赠送课程
  BY_GIFT: 'pay/activation/byGiftKey',
  // --------------------------  Better课程 end  --------------------------
  // -------------------------- 用户 start --------------------------------
  // 获取用户信息
  USER_INFO: 'user/info',
  // 编辑用户信息
  EDIT_USER: 'user/edit',
  // 检查手机号
  CHECK_MOBILE: 'user/checkMobile',
  // 发送验证码
  SEND_CODE: 'user/sendSMSCode',
  // 绑定手机号
  BIND_MOBILE: 'user/bindMoblie',
  // 用户账户信息
  ACCOUNT_INFO: 'user/getAccountInfo',
  // 交易记录
  TRADE_RECORD: 'user/getTradeRecords',
  // 交易记录详情
  TRADE_RECORD_INFO: 'user/getTradeRecordInfo',
  // 提现记录
  WITH_DRAW: 'finance/withdraw/getList',
  // 提现申请
  WITH_DRAW_APPLY: 'finance/withdraw/apply',
  // 提现详情
  WITH_DRAW_INFO: 'finance/withdraw/info',
  // 税金计算
  WITH_DRAW_TAX: 'finance/withdraw/getTax',
  // 实名认证
  REALNAME_AUTH: 'user/realnameAuth',
  // 实名认证信息
  REALNAME_AUTH_INFO: 'user/getRealnameAuthInfo',
  // 获取意见反馈
  FEED_BACK: 'other/feedback/getList',
  // 意见反馈详情
  FEED_BACK_INFO: 'other/feedback/info',
  // 新增意见反馈
  ADD_FEED_BACK: 'other/feedback/add',
  // 删除意见反馈
  DEL_FEED_BACK: 'other/feedback/delete',
  // 获取通知消息列表
  NOTICE_LIST: 'other/notice/getList',
  // 设置通知消息已读
  NOTICE_READ: 'other/notice/setRead',
  // 获取通知消息未读的数量
  NOTICE_UNREAD_COUNT: 'other/notice/getUnreadCount',
  // 删除通知消息
  NOTICE_DEL: 'other/notice/delete',
  // 日历列表
  CALENDAR_LIST: 'user/calendar/getList',
  // 检查今日打卡状态
  CHECK_IN_STATUS: 'user/checkIn/status',
  // 签到打卡
  CHECK_IN: 'user/checkIn/action',
  // 获取用户日记列表
  DIARY_LIST: 'user/diary/getList',
  // 获取用户日历详情
  DIARY_INFO: 'user/diary/info',
  // 新增、编辑日记
  DIARY_EDIT: 'user/diary/store',
  // 删除日记
  DIARY_DEL: 'user/diary/delete',
  // -------------------------- 用户 end ----------------------------------
  // -------------------------  考试 start --------------------------------
  // 获取用户考试列表
  EXAM_LIST: 'exam/getUserExamList',
  // 获取用户试卷信息
  EXAM_INFO: 'exam/getUserExamInfo',
  // 开始考试
  EXAM_BEGIN: 'exam/startExam',
  // 获取考试试题
  EXAM_QUESTION: 'exam/getQuestion',
  // 提交试卷
  EXAM_SUBMIT: 'exam/submitAnswers',
  // 查看结果
  EXAM_RESULT: 'exam/getAnswerResult',
  // 查看错题
  EXAM_WRONG: 'exam/getWrongQuestions',
  // -------------------------- 考试 end ----------------------------------
  // --------------------------  Read青音共读会 start  ---------------------
  // 初始化
  INIT: 'common/init',
  // 获取微信开发列表
  getJSLIST: 'other/util/base',
  // 获取分享设置
  GET_SHARE: 'other/share/getConfig',
  // 激活码激活课程
  ACTIVE_CODE: 'pay/activation/byCode',
  // 渠道领取
  ACTIVE_BY_CHANNELKEY: 'pay/activation/byChannelKey',
  // 购买成功
  PAY_SUCCESS: 'pay/success',
  // 获取二维码
  GET_QRCODE: 'common/g_qrcode',
  // 二维码识别次数
  S_QRCOUNT: 'other/qrcode/identifyInc',
  // 初始化
  INIT_CONFIG: 'init/config',
  // 获取专栏列表
  PACKAGE_LIST: 'read/package/getList',
  // 专栏详情
  PACKAGE_INFO: 'read/package/info',
  // 专栏下的图书列表
  BOOK_LIST: 'read/book/getList',
  // 图书详情
  BOOK_INFO: 'read/book/info',
  // 图书音频播放
  BOOK_PLAY: 'read/book/play',
  // 直播列表1
  LIVE_LIST: 'read/live/getList',
  // 直播邀请码
  LIVE_CODE: 'read/live/getInviteCode',
  // 点赞榜列表
  RANK_LIST: 'read/ranking/getList',
  // 点赞榜基本信息
  RANK_INFO: 'read/ranking/info',
  // 空间信息
  ZONE_INFO: 'read/zone/info',
  // 获取我的空间列表
  MOMENT_LIST: 'read/moments/getList',
  // 获取moment详情
  MOMENT_INFO: 'read/moments/info',
  // 设置动态为公开/私密
  SET_PUBLIC: 'read/moments/setPublic',
  // 删除用户动态
  DEL_MOMENT: 'read/moments/delete',
  // 发布用户动态
  SEND_MOMENT: 'read/moments/send',
  // 点赞用户状态
  SET_LIKE: 'read/moments/setLike',
  // 举报
  REPORT: 'read/report',
  // -----------------------  Read 青音共读会 end  -------------------
  // -----------------------  Radio 青音夜谈 start  ------------------
  RADIO_INFO: 'radio/info',
  // 夜谈章节时间范围
  RADIO_SECTION_RANGE: 'section/getRange',
  // -----------------------  Radio 青音夜谈 end  ------------------
  // -----------------------  优惠券  ------------------------------
  COUPON_LIST: 'coupon/getCDList',
  // 优惠券详情
  COUPON_INFO: 'coupon/getCDInfo',
  // 优惠券核销
  COUPON_WRITEOFF: 'coupon/writeoff'
};

/***/ }),

/***/ "FbWN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// const baseSize = 32
function setRem() {
    // const scale = document.documentElement.clientWidth / 750
    // document.documentElement.style.fontSize = (baseSize * Math.min(scale, 2)) + 'px'
    document.documentElement.style.fontSize = document.documentElement.clientWidth / 7.5 + 'px';
}
setRem();
window.onresize = function () {
    setRem();
};

/***/ }),

/***/ "IcnI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__("NYxO");

var _vuex2 = _interopRequireDefault(_vuex);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

var state = {
    allowBack: '',
    orderId: '',
    menu: []
};

var getters = {
    getAllowBack: function getAllowBack(state) {
        return state.allowBack;
    },
    getOrderId: function getOrderId(state) {
        return state.orderId;
    },
    getMenu: function getMenu(state) {
        return state.menu;
    }
};
var mutations = {
    setAllowBack: function setAllowBack(state, allowBack) {
        state.allowBack = allowBack;
    },
    setOrderId: function setOrderId(state, orderId) {
        state.orderId = orderId;
    },
    setMenu: function setMenu(state, menu) {
        state.menu = menu;
    }
};

var actions = {
    allowBack: function allowBack(_ref, _allowBack) {
        var commit = _ref.commit;

        commit('setAllowBack', _allowBack);
    },
    orderId: function orderId(_ref2, _orderId) {
        var commit = _ref2.commit;

        commit('setOrderId', _orderId);
    },
    menu: function menu(_ref3, _menu) {
        var commit = _ref3.commit;

        commit('setMenu', _menu);
    }
};

exports.default = new _vuex2.default.Store({
    namespaced: true,
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions
});

/***/ }),

/***/ "Kcpa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KvKp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  dateFormat: dateFormat,
  numberFormat: numberFormat,
  numberRandom: numberRandom
  // 日期格式化 date为毫秒 fmt显示模板
};
function dateFormat(date) {
  var fmt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY-MM-DD HH:mm:ss';

  if (!date) {
    return '';
  }
  if (typeof date === 'string') {
    date = new Date(date.replace(/-/g, '/'));
  }
  if (typeof date === 'number') {
    date = new Date(date);
  }
  var o = {
    'M+': date.getMonth() + 1,
    'D+': date.getDate(),
    'h+': date.getHours() % 12 === 0 ? 12 : date.getHours() % 12,
    'H+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
    'q+': Math.floor((date.getMonth() + 3) / 3),
    'S': date.getMilliseconds()
  };
  var week = {
    '0': '\u65E5',
    '1': '\u4E00',
    '2': '\u4E8C',
    '3': '\u4E09',
    '4': '\u56DB',
    '5': '\u4E94',
    '6': '\u516D'
  };
  if (/(Y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  if (/(E+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (RegExp.$1.length > 1 ? RegExp.$1.length > 2 ? '\u661F\u671F' : '\u5468' : '') + week[date.getDay() + '']);
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
    }
  }
  return fmt;
}
// 数字格式化 source:数字 length分割的长度
function numberFormat(source) {
  var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;

  source = String(source).split('.');
  source[0] = source[0].replace(new RegExp('(\\d)(?=(\\d{' + length + '})+$)', 'ig'), '$1,');
  return source.join('.');
}
// 取随机数 min最小值 max最大值
function numberRandom(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}

/***/ }),

/***/ "LSib":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_requestAnimationFrame__ = __webpack_require__("D7+0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_requestAnimationFrame___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__utils_requestAnimationFrame__);
//
//
//
//
//
//
//
//
//
//

/**
 * ly-tab
 * @desc 依赖 tab-item
 * @param {Boolean} fixBottom - 固定底部
 * @param {*} value - 返回 item component 传入的 id
 *
 * @example
 * <ly-tab v-model="selected"> // v-model只是一个双向绑定的语法糖
      <ly-tab-item v-for="(item, index) in tabList" :key="index">
        {{item.itemName}}
      </ly-tab-item>
    </ly-tab>
 */


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LyTab',
  props: {
    lineWidth: {
      type: Number,
      default: 1
    },
    activeColor: {
      type: String,
      default: 'red'
    },
    fixBottom: {
      type: Boolean,
      default: false
    },
    value: {},

    // 近似等于超出边界时最大可拖动距离(px);
    additionalX: {
      type: Number,
      default: 50
    },
    // 惯性回弹指数(值越大，幅度越大，惯性回弹距离越长);
    reBoundExponent: {
      type: Number,
      default: 10
    },
    // 灵敏度(惯性滑动时的灵敏度,值越小，阻力越大),可近似认为速度减为零所需的时间(ms);
    sensitivity: {
      type: Number,
      default: 1000
    },
    // 回弹过程duration;
    reBoundingDuration: {
      type: Number,
      default: 360
    }
  },
  computed: {
    style: function style() {
      return {
        transitionTimingFunction: this.transitionTimingFunction,
        transitionDuration: this.transitionDuration + 'ms',
        transform: 'translate3d(' + this.translateX + 'px, 0px, 0px)'
      };
    },
    transitionDuration: function transitionDuration() {
      if (this.touching || !this.reBounding && !this.touching) {
        return '0';
      }
      if (this.reBounding && !this.touching) {
        return this.reBoundingDuration;
      }
    },
    transitionTimingFunction: function transitionTimingFunction() {
      return this.reBounding ? 'cubic-bezier(0.25, 0.46, 0.45, 0.94)' : 'cubic-bezier(0.1, 0.57, 0.1, 1)';
    },

    // 可视区宽度;
    viewAreaWidth: function viewAreaWidth() {
      return this.$refs.viewArea.offsetWidth;
    },

    // 可视区与可滑动元素宽度差值;
    listWidth: function listWidth() {
      return this.$refs.list.offsetWidth - this.viewAreaWidth;
    },

    // 是否向左惯性滚动;
    isMoveLeft: function isMoveLeft() {
      return this.currentX <= this.startX;
    },
    isMoveRight: function isMoveRight() {
      return this.currentX >= this.startX;
    }
  },
  data: function data() {
    return {
      speed: 0, // 滑动速度(正常滑动时一般不会超过10);
      touching: false, // 是否处于touch状态;
      reBounding: false, // 是否处于回弹过程;
      translateX: 0,
      startX: 0,
      lastX: 0,
      currentX: 0,
      frameTime: 16.7, // 每个动画帧的ms数
      frameStartTime: 0,
      frameEndTime: 0,
      inertiaFrame: 0,
      zeroSpeed: 0.001, // 当speed绝对值小于该值时认为速度为0 (可用于控制惯性滚动结束期的顺滑度)
      acceleration: 0 // 惯性滑动加速度;
    };
  },
  mounted: function mounted() {
    this.bindEvent();
  },

  methods: {
    // start
    handleTouchStart: function handleTouchStart(event) {
      cancelAnimationFrame(this.inertiaFrame);
      this.lastX = event.touches[0].clientX;
    },

    // move
    handleTouchMove: function handleTouchMove(event) {
      if (this.listWidth <= 0) return;
      event.preventDefault();
      event.stopPropagation();
      this.touching = true;
      this.startMoveTime = this.endMoveTime;
      this.startX = this.lastX;
      this.currentX = event.touches[0].clientX;
      this.moveFellowTouch();
      this.endMoveTime = event.timeStamp; // 每次触发touchmove事件的时间戳;
    },

    // end
    handleTouchEnd: function handleTouchEnd(event) {
      this.touching = false;
      if (this.checkReboundX()) {
        cancelAnimationFrame(this.inertiaFrame);
      } else {
        var silenceTime = event.timeStamp - this.endMoveTime;
        var timeStamp = this.endMoveTime - this.startMoveTime;
        if (silenceTime > 100) return; // 停顿时间超过100ms不产生惯性滑动;
        this.speed = (this.lastX - this.startX) / timeStamp;
        this.acceleration = this.speed / this.sensitivity;
        this.frameStartTime = new Date().getTime();
        this.inertiaFrame = requestAnimationFrame(this.moveByInertia);
      }
    },

    // 如果需要回弹则进行回弹操作并返回true;
    checkReboundX: function checkReboundX() {
      this.reBounding = false;
      if (this.translateX > 0) {
        this.reBounding = true;
        this.translateX = 0;
      } else if (this.translateX < -this.listWidth) {
        this.reBounding = true;
        this.translateX = -this.listWidth;
      }
      return this.translateX === 0 || this.translateX === -this.listWidth;
    },
    bindEvent: function bindEvent() {
      this.$el.addEventListener('touchstart', this.handleTouchStart, false);
      this.$el.addEventListener('touchmove', this.handleTouchMove, false);
      this.$el.addEventListener('touchend', this.handleTouchEnd, false);
    },

    // touch拖动
    moveFellowTouch: function moveFellowTouch() {
      if (this.isMoveLeft) {
        // 向左拖动
        if (this.translateX <= 0 && this.translateX + this.listWidth > 0 || this.translateX > 0) {
          this.translateX += this.currentX - this.lastX;
        } else if (this.translateX + this.listWidth <= 0) {
          this.translateX += this.additionalX * (this.currentX - this.lastX) / (this.viewAreaWidth + Math.abs(this.translateX + this.listWidth));
        }
      } else {
        // 向右拖动
        if (this.translateX >= 0) {
          this.translateX += this.additionalX * (this.currentX - this.lastX) / (this.viewAreaWidth + this.translateX);
        } else if (this.translateX <= 0 && this.translateX + this.listWidth >= 0 || this.translateX + this.listWidth <= 0) {
          this.translateX += this.currentX - this.lastX;
        }
      }
      this.lastX = this.currentX;
    },

    // 惯性滑动
    moveByInertia: function moveByInertia() {
      this.frameEndTime = new Date().getTime();
      this.frameTime = this.frameEndTime - this.frameStartTime;
      if (this.isMoveLeft) {
        // 向左惯性滑动;
        if (this.translateX <= -this.listWidth) {
          // 超出边界的过程;
          // 加速度指数变化;
          this.acceleration *= (this.reBoundExponent + Math.abs(this.translateX + this.listWidth)) / this.reBoundExponent;
          this.speed = Math.min(this.speed - this.acceleration, 0); // 为避免减速过程过短，此处加速度没有乘上frameTime;
        } else {
          this.speed = Math.min(this.speed - this.acceleration * this.frameTime, 0);
        }
      } else if (this.isMoveRight) {
        // 向右惯性滑动;
        if (this.translateX >= 0) {
          this.acceleration *= (this.reBoundExponent + this.translateX) / this.reBoundExponent;
          this.speed = Math.max(this.speed - this.acceleration, 0);
        } else {
          this.speed = Math.max(this.speed - this.acceleration * this.frameTime, 0);
        }
      }
      this.translateX += this.speed * this.frameTime / 2;
      if (Math.abs(this.speed) <= this.zeroSpeed) {
        this.checkReboundX();
        return;
      }
      this.frameStartTime = this.frameEndTime;
      this.inertiaFrame = requestAnimationFrame(this.moveByInertia);
    }
  }
});

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_141cf7f2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("gF8e");
function injectStyle (ssrContext) {
  __webpack_require__("fc2l")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_141cf7f2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "NDvL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vant_es_toast_style__ = __webpack_require__("eqfM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vant_es_toast__ = __webpack_require__("/QYm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vant_es_rate_style__ = __webpack_require__("gi6D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vant_es_rate__ = __webpack_require__("XPjg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_js_common_js__ = __webpack_require__("2Uyi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_js_common_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_js_common_js__);



 //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Menu',
    props: ['menuList', 'backTop', 'back'],
    data: function data() {
        return {
            menuFlag: false,
            show: false,
            shia: false,
            timer: null
        };
    },

    components: {
        Rate: __WEBPACK_IMPORTED_MODULE_3_vant_es_rate__["a" /* default */]
    },
    created: function created() {
        this.setTimer();
    },

    methods: {
        setTimer: function setTimer() {
            var that = this;
            if (that.menuFlag == false) {
                this.timer = setInterval(function () {
                    that.menuFlag = true;
                    clearInterval(that.timer);
                    that.timer = null;
                }, 10000);
            }
        },
        menuShow: function menuShow() {
            clearInterval(this.timer);
            this.timer = null;
            this.menuFlag = false;
            this.setTimer();
        },
        goUrl: function goUrl(name, v, flag) {
            __WEBPACK_IMPORTED_MODULE_4__assets_js_common_js___default.a.goRouter(this, name, v, flag);
        },

        // 返回顶部
        goTop: function goTop() {
            this.$emit('goTop');
        },

        // 点击按钮图标
        menuFc: function menuFc(obj) {
            if (obj.router) {
                this.goUrl(obj.router);
            } else if (obj.icon == 'stor') {
                // 评分
                if (obj.val === 0) {
                    this.show = !this.show;
                } else {
                    Object(__WEBPACK_IMPORTED_MODULE_1_vant_es_toast__["default"])('你已评分');
                }
            } else if (obj.icon == 'wodekecheng-01') {
                this.goUrl('myCourse');
            } else if (obj.icon == '1_fuzhi-01') {
                // 生成上图
                this.$emit('canvasImage');
            } else {
                this.$emit('menuCallback');
            }
        }
    }
});

/***/ }),

/***/ "NHnr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__("M93x");

var _App2 = _interopRequireDefault(_App);

var _router = __webpack_require__("YaEn");

var _router2 = _interopRequireDefault(_router);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

var _store = __webpack_require__("IcnI");

var _store2 = _interopRequireDefault(_store);

var _vueCookie = __webpack_require__("K/Lq");

var _vueCookie2 = _interopRequireDefault(_vueCookie);

var _axios3 = __webpack_require__("pxwZ");

var _axios4 = _interopRequireDefault(_axios3);

__webpack_require__("VaBq");

__webpack_require__("Qbok");

__webpack_require__("uVdW");

__webpack_require__("+S4w");

__webpack_require__("+K7v");

var _weixinJsSdk = __webpack_require__("fxnj");

var _weixinJsSdk2 = _interopRequireDefault(_weixinJsSdk);

var _share = __webpack_require__("r/Ju");

var _share2 = _interopRequireDefault(_share);

__webpack_require__("FbWN");

var _utils = __webpack_require__("KvKp");

var _utils2 = _interopRequireDefault(_utils);

var _vueBa = __webpack_require__("ZCU/");

var _vueBa2 = _interopRequireDefault(_vueBa);

var _vueClipboard = __webpack_require__("wvfG");

var _vueClipboard2 = _interopRequireDefault(_vueClipboard);

__webpack_require__("7t+N");

var _antDesignVue = __webpack_require__("2vhu");

var _antDesignVue2 = _interopRequireDefault(_antDesignVue);

var _vueAwesomeSwiper = __webpack_require__("7QTg");

var _vueAwesomeSwiper2 = _interopRequireDefault(_vueAwesomeSwiper);

__webpack_require__("BpKH");

var _gradients = __webpack_require__("zNJb");

var _gradients2 = _interopRequireDefault(_gradients);

var _hover_menu = __webpack_require__("AeCp");

var _hover_menu2 = _interopRequireDefault(_hover_menu);

var _scroll = __webpack_require__("0tE7");

var _scroll2 = _interopRequireDefault(_scroll);

var _lyTab = __webpack_require__("7HVg");

var _lyTab2 = _interopRequireDefault(_lyTab);

__webpack_require__("iPOO");

var _videojsContribHls = __webpack_require__("Jg0P");

var _videojsContribHls2 = _interopRequireDefault(_videojsContribHls);

__webpack_require__("g3Gj");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// read公共样式
// 基础公共样式
// card公共样式
// 青音共读会的图标
_vue2.default.use(_lyTab2.default); // better的图标
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

_vue2.default.use(_antDesignVue2.default);
_vue2.default.use(_axios4.default);
_vue2.default.use(_vueCookie2.default);
_vue2.default.use(_vueAwesomeSwiper2.default);
_vue2.default.use(_vueBa2.default, '44b29c1bdfb2a63ae7ba8f27e4ffeee6');
_vue2.default.use(_vueBa2.default, { siteId: '44b29c1bdfb2a63ae7ba8f27e4ffeee6' });
_vue2.default.use(_vueClipboard2.default);
_vue2.default.config.productionTip = false;
_vue2.default.component('hover-menu', _hover_menu2.default);
_vue2.default.component('scroll-list', _scroll2.default);
_vue2.default.component('gradients', _gradients2.default);
_vue2.default.use(_videojsContribHls2.default);
// 挂载wx
_vue2.default.prototype.$wx = _weixinJsSdk2.default;
_vue2.default.prototype.$wxShare = _share2.default;
_vue2.default.prototype.$http = _axios2.default;
_vue2.default.prototype.utils = _utils2.default;
_axios2.default.defaults.withCredentials = true; // 让ajax携带cookie
/* eslint-disable no-new */
// 格式化时间
_vue2.default.filter('dataFormat', function (value, fmt) {
  var getDate = new Date(value.replace(/-/g, '/'));
  var o = {
    'M+': getDate.getMonth() + 1,
    'd+': getDate.getDate(),
    'h+': getDate.getHours(),
    'm+': getDate.getMinutes(),
    's+': getDate.getSeconds(),
    'q+': Math.floor((getDate.getMonth() + 3) / 3),
    'S': getDate.getMilliseconds()
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (getDate.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
    }
  }
  return fmt;
});
new _vue2.default({
  el: '#app',
  router: _router2.default,
  store: _store2.default,
  template: '<App/>',
  components: { App: _App2.default }
});

/***/ }),

/***/ "Qbok":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "T2s0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "T452":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
var config = exports.config = {
	status: {
		'0': '成功'
	}
};

/***/ }),

/***/ "VR12":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"viewArea",staticClass:"ly-tab",class:{'ly-tab-fix-bottom': _vm.fixBottom}},[_c('div',{ref:"list",staticClass:"ly-tab-list",style:(_vm.style)},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VaBq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VfRW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_tab_vue__ = __webpack_require__("LSib");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_0d62204c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_tab_vue__ = __webpack_require__("VR12");
function injectStyle (ssrContext) {
  __webpack_require__("fJZj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_tab_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_0d62204c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_tab_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "WpgC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XN5v":
/***/ (function(module, exports) {

module.exports = {"_args":[["ant-design-vue@1.6.2","/Users/apple/Desktop/qyh/better_h5_clone"]],"_from":"ant-design-vue@1.6.2","_id":"ant-design-vue@1.6.2","_inBundle":false,"_integrity":"sha1-mDY0yqyc2soLOglbVAEFtPdtop8=","_location":"/ant-design-vue","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"ant-design-vue@1.6.2","name":"ant-design-vue","escapedName":"ant-design-vue","rawSpec":"1.6.2","saveSpec":null,"fetchSpec":"1.6.2"},"_requiredBy":["/"],"_resolved":"https://registry.npm.taobao.org/ant-design-vue/download/ant-design-vue-1.6.2.tgz","_spec":"1.6.2","_where":"/Users/apple/Desktop/qyh/better_h5_clone","bugs":{"url":"https://github.com/vueComponent/ant-design-vue/issues"},"dependencies":{"@ant-design/icons":"^2.1.1","@ant-design/icons-vue":"^2.0.0","add-dom-event-listener":"^1.0.2","array-tree-filter":"^2.1.0","async-validator":"^3.0.3","babel-helper-vue-jsx-merge-props":"^2.0.3","babel-runtime":"6.x","classnames":"^2.2.5","component-classes":"^1.2.6","dom-align":"^1.10.4","dom-closest":"^0.2.0","dom-scroll-into-view":"^2.0.0","enquire.js":"^2.1.6","intersperse":"^1.0.0","is-mobile":"^2.2.1","is-negative-zero":"^2.0.0","ismobilejs":"^1.0.0","json2mq":"^0.2.0","lodash":"^4.17.5","moment":"^2.21.0","mutationobserver-shim":"^0.3.2","node-emoji":"^1.10.0","omit.js":"^1.0.0","raf":"^3.4.0","resize-observer-polyfill":"^1.5.1","shallow-equal":"^1.0.0","shallowequal":"^1.0.2","vue-ref":"^2.0.0","warning":"^4.0.0"},"description":"An enterprise-class UI design language and Vue-based implementation","devDependencies":{"@commitlint/cli":"^8.0.0","@commitlint/config-conventional":"^8.0.0","@octokit/rest":"^16.0.0","@vue/cli-plugin-eslint":"^4.0.0","@vue/server-test-utils":"1.0.0-beta.16","@vue/test-utils":"1.0.0-beta.16","acorn":"^7.0.0","autoprefixer":"^9.6.0","axios":"^0.19.0","babel-cli":"^6.26.0","babel-core":"^6.26.0","babel-eslint":"^10.0.1","babel-helper-vue-jsx-merge-props":"^2.0.3","babel-jest":"^23.6.0","babel-loader":"^7.1.2","babel-plugin-import":"^1.1.1","babel-plugin-inline-import-data-uri":"^1.0.1","babel-plugin-istanbul":"^6.0.0","babel-plugin-syntax-dynamic-import":"^6.18.0","babel-plugin-syntax-jsx":"^6.18.0","babel-plugin-transform-class-properties":"^6.24.1","babel-plugin-transform-decorators":"^6.24.1","babel-plugin-transform-decorators-legacy":"^1.3.4","babel-plugin-transform-es3-member-expression-literals":"^6.22.0","babel-plugin-transform-es3-property-literals":"^6.22.0","babel-plugin-transform-object-assign":"^6.22.0","babel-plugin-transform-object-rest-spread":"^6.26.0","babel-plugin-transform-runtime":"~6.23.0","babel-plugin-transform-vue-jsx":"^3.7.0","babel-polyfill":"^6.26.0","babel-preset-env":"^1.6.1","case-sensitive-paths-webpack-plugin":"^2.1.2","chalk":"^3.0.0","cheerio":"^1.0.0-rc.2","codecov":"^3.0.0","colorful":"^2.1.0","commander":"^4.0.0","compare-versions":"^3.3.0","cross-env":"^7.0.0","css-loader":"^3.0.0","deep-assign":"^2.0.0","enquire-js":"^0.2.1","eslint":"^6.8.0","eslint-config-prettier":"^6.10.1","eslint-plugin-html":"^6.0.0","eslint-plugin-markdown":"^2.0.0-alpha.0","eslint-plugin-vue":"^6.2.2","fetch-jsonp":"^1.1.3","fs-extra":"^8.0.0","glob":"^7.1.2","gulp":"^4.0.1","gulp-babel":"^7.0.0","gulp-strip-code":"^0.1.4","html-webpack-plugin":"^3.2.0","husky":"^4.0.0","istanbul-instrumenter-loader":"^3.0.0","jest":"^24.0.0","jest-serializer-vue":"^2.0.0","jest-transform-stub":"^2.0.0","js-base64":"^2.4.8","json-templater":"^1.2.0","jsonp":"^0.2.1","less":"^3.9.0","less-loader":"^6.0.0","less-plugin-npm-import":"^2.1.0","lint-staged":"^10.0.0","marked":"0.3.18","merge2":"^1.2.1","mini-css-extract-plugin":"^0.9.0","minimist":"^1.2.0","mkdirp":"^0.5.1","mockdate":"^2.0.2","nprogress":"^0.2.0","optimize-css-assets-webpack-plugin":"^5.0.1","postcss":"^7.0.6","postcss-loader":"^3.0.0","prettier":"^1.18.2","pretty-quick":"^2.0.0","querystring":"^0.2.0","raw-loader":"^4.0.0","reqwest":"^2.0.5","rimraf":"^3.0.0","rucksack-css":"^1.0.2","selenium-server":"^3.0.1","semver":"^7.0.0","style-loader":"^1.0.0","stylelint":"^13.0.0","stylelint-config-prettier":"^8.0.0","stylelint-config-standard":"^19.0.0","terser-webpack-plugin":"^2.3.1","through2":"^3.0.0","url-loader":"^3.0.0","vue":"^2.6.11","vue-antd-md-loader":"^1.1.0","vue-clipboard2":"0.3.1","vue-draggable-resizable":"^2.1.0","vue-eslint-parser":"^7.0.0","vue-i18n":"^8.3.2","vue-infinite-scroll":"^2.0.2","vue-jest":"^2.5.0","vue-loader":"^15.6.2","vue-router":"^3.0.1","vue-server-renderer":"^2.6.11","vue-template-compiler":"^2.6.11","vue-virtual-scroller":"^1.0.0","vuex":"^3.1.0","webpack":"^4.28.4","webpack-cli":"^3.2.1","webpack-dev-server":"^3.1.14","webpack-merge":"^4.1.1","webpackbar":"^4.0.0","xhr-mock":"^2.5.1"},"files":["dist","lib","es","types","scripts"],"homepage":"https://www.antdv.com/","keywords":["ant","design","antd","vue","vueComponent","component","components","ui","framework","frontend"],"license":"MIT","main":"lib/index.js","module":"es/index.js","name":"ant-design-vue","peerDependencies":{"vue":">=2.6.0","vue-template-compiler":">=2.6.0"},"repository":{"type":"git","url":"git+https://github.com/vueComponent/ant-design-vue.git"},"scripts":{"codecov":"codecov","compile":"node antd-tools/cli/run.js compile","dev":"webpack-dev-server","dist":"node antd-tools/cli/run.js dist","lint":"eslint -c ./.eslintrc --fix --ext .jsx,.js,.vue ./components","lint:docs":"eslint -c ./.eslintrc --fix --ext .jsx,.js,.vue,.md ./antdv-demo/docs/**/demo/**","lint:site":"eslint -c ./.eslintrc --fix --ext .jsx,.js,.vue ./antdv-demo","lint:style":"stylelint \"{site,components}/**/*.less\" --syntax less","postinstall":"node scripts/postinstall || echo \"ignore\"","pre-publish":"node ./scripts/prepub","prepublish":"node antd-tools/cli/run.js guard","prettier":"prettier -c --write '**/*'","pretty-quick":"pretty-quick","pub":"node antd-tools/cli/run.js pub","pub-with-ci":"node antd-tools/cli/run.js pub-with-ci","start":"cross-env NODE_ENV=development webpack-dev-server --config webpack.config.js","test":"cross-env NODE_ENV=test jest --config .jest.js"},"sideEffects":["site/*","components/style.js","components/**/style/*","*.vue","*.md","dist/*","es/**/style/*","lib/**/style/*","*.less"],"title":"Ant Design Vue","typings":"types/index.d.ts","version":"1.6.2"}

/***/ }),

/***/ "YaEn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__("/ocq");

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _book = __webpack_require__("aK6G");

var api = _interopRequireWildcard(_book);

var _share = __webpack_require__("r/Ju");

var _share2 = _interopRequireDefault(_share);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import common from '@/assets/js/common.js'
_vue2.default.use(_vueRouter2.default);
var router = new _vueRouter2.default({
  mode: 'history',
  routes: [{
    // 首页
    path: '/home',
    name: 'home',
    meta: { index: 0, allowBack: false },
    component: function component() {
      return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, "vkyI"));
    }
  }, {
    // 引导页
    path: '/onboarding',
    name: 'onboarding',
    meta: { index: 0, allowBack: false },
    component: function component() {
      return __webpack_require__.e/* import() */(37).then(__webpack_require__.bind(null, "3At3"));
    }
  }, {
    // 激活页
    path: '/pay/activate',
    name: 'activate',
    meta: { share: true },
    component: function component() {
      return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, "ZRps"));
    }
  }, {
    // 激活成功页
    path: '/pay/paySuccess',
    name: 'paySuccess',
    meta: { allowBack: false, share: true },
    component: function component() {
      return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, "K1Yj"));
    }
  }, {
    // 课程列表
    path: '/course/list',
    name: 'courseList',
    component: function component() {
      return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, "/cX6"));
    }
  }, {
    // 我的课程
    path: '/course/mycourse',
    name: 'myCourse',
    component: function component() {
      return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, "3FqH"));
    }
  }, {
    // 章节列表
    path: '/course/chapter/:rtype/:rpid/:rid',
    name: 'chapterList',
    component: function component() {
      return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "i6Av"));
    }
  }, {
    // 售卖页
    path: '/course/sale/:rtype/:rid',
    name: 'sale',
    component: function component() {
      return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, "r52g"));
    }
  }, {
    // 播放sid(section_id)oid(option_id)
    path: '/course/play/:rtype/:rpid/:rid/:sid/:oid?/:scid?',
    name: 'coursePlay',
    meta: { share: true },
    component: function component() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "RAS0"));
    }
  }, {
    // 优惠券
    path: '/coupon',
    name: 'coupon',
    component: function component() {
      return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, "1byp"));
    }
  }, {
    // 支付页
    path: '/coupon/apply',
    name: 'apply',
    component: function component() {
      return __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, "jETb"));
    }
  }, {
    // 核销页from=1来源支付from=2来源于线下课程ca=1核销员身份
    path: '/coupon/writeoff',
    name: 'writeoff',
    component: function component() {
      return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, "A6oy"));
    }
  }, {
    // 考试列表
    path: '/course/examlist',
    name: 'examList',
    component: function component() {
      return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, "rjVk"));
    }
  }, {
    // 考试题目
    path: '/course/exam_questions/:id/:t/:n',
    name: 'examQuestions',
    component: function component() {
      return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, "dVmu"));
    }
  }, {
    // 考试结果
    path: '/course/exam_result/:id',
    name: 'examResult',
    component: function component() {
      return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, "sif7"));
    }
  }, {
    // 个人中心
    path: '/mine',
    name: 'mine',
    component: function component() {
      return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, "jEqI"));
    }
  }, {
    // 编辑个人信息
    path: '/my/edit',
    name: 'edit',
    component: function component() {
      return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, "8rae"));
    }
  }, {
    // 我的钱包
    path: '/my/wallet',
    name: 'wallet',
    component: function component() {
      return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, "8DoY"));
    }
  }, {
    // 交易记录
    path: '/my/bill',
    name: 'bill',
    component: function component() {
      return __webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, "XClF"));
    }
  }, {
    // 提现
    path: '/my/cashout',
    name: 'cashOut',
    component: function component() {
      return __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, "1xtq"));
    }
  }, {
    // 提现记录
    path: '/my/cashrecord',
    name: 'cashRecord',
    component: function component() {
      return __webpack_require__.e/* import() */(36).then(__webpack_require__.bind(null, "y7ue"));
    }
  }, {
    // 提现明细
    path: '/my/cashdetail',
    name: 'cashDetail',
    component: function component() {
      return __webpack_require__.e/* import() */(34).then(__webpack_require__.bind(null, "DXVl"));
    }
  }, {
    // 我的日记
    path: '/my/diary',
    name: 'diary',
    component: function component() {
      return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, "YBw2"));
    }
  }, {
    // 编辑日记、日记详情
    path: '/my/editdiary',
    name: 'diaryEdit',
    component: function component() {
      return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, "Es64"));
    }
  }, {
    // 系统消息
    path: '/my/system',
    name: 'systemMessage',
    component: function component() {
      return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, "BQ7w"));
    }
  }, {
    // 我的日历
    path: '/my/calendar/:rtype?/:rid?',
    name: 'myCalendar',
    component: function component() {
      return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, "UcrU"));
    }
  }, {
    // 意见反馈
    path: '/my/feedback',
    name: 'feedback',
    component: function component() {
      return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, "Y9yA"));
    }
  }, {
    // 意见反馈详情
    path: '/my/feedback_detail',
    name: 'feedbackDetail',
    component: function component() {
      return __webpack_require__.e/* import() */(38).then(__webpack_require__.bind(null, "xUFV"));
    }
  }, {
    // 书签
    path: '/course/bookmark',
    name: 'bookMark',
    component: function component() {
      return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, "DrxC"));
    }
  }, {
    // 实名认证
    path: '/my/certification',
    name: 'certification',
    component: function component() {
      return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, "ztMc"));
    }
  }, {
    // 首页
    path: '/read/index',
    name: 'bookIndex',
    component: function component() {
      return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, "qD5z"));
    }
  }, {
    // 共读播放页
    path: '/read/play',
    // /:pid/:bid
    name: 'play',
    meta: { share: true },
    component: function component() {
      return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, "wGLp"));
    }
  }, {
    // 共读专区
    path: '/read/ranking',
    name: 'ranking',
    component: function component() {
      return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, "hQzp"));
    }
  }, {
    // 个人空间
    path: '/read/space',
    name: 'space',
    meta: { share: true },
    component: function component() {
      return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, "QKti"));
    }

  }, {
    // 发布语音页
    path: '/read/issue',
    name: 'issue',
    component: function component() {
      return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, "LxX3"));
    }

  }, {
    // 直播专区页
    path: '/read/live',
    name: 'live',
    component: function component() {
      return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, "3V9l"));
    }
  }, {
    // 分享页
    path: '/read/share',
    name: 'share',
    meta: { allowBack: false, share: true },
    component: function component() {
      return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, "GEJs"));
    }
  }, {
    // 公共维护页
    path: '/read/base',
    name: 'base',
    meta: { index: 0, allowBack: false },
    component: function component() {
      return __webpack_require__.e/* import() */(35).then(__webpack_require__.bind(null, "TAH1"));
    }
  },
  // 夜谈首页
  {
    path: '/radio/index',
    name: 'radioIndex',
    component: function component() {
      return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "hXnj"));
    }
  }, {
    // 上部均未匹配到则重定向至书单首页
    path: '*',
    meta: { index: 0, allowBack: false },
    redirect: { name: 'home' }
  }]
});

// 路由拦截
router.beforeEach(function (to, from, next) {
  // 除去特殊分享的页面(一般页面)
  var shareData = sessionStorage.getItem('initData');
  if (to.name != 'onboarding' && !to.meta.share) {
    if (shareData) {
      _share2.default.baseConfig(JSON.parse(shareData).share, function (res) {
        sessionStorage.setItem('noticeUnread', res.notice_unread);
        var s = new Date(res.onboarding.start_time.replace(/-/g, '/')).getTime();
        var e = new Date(res.onboarding.end_time.replace(/-/g, '/')).getTime();
        var n = new Date().getTime();
        // 时间一致
        if (n > s && n < e && res.onboarding.status == '1') {
          // key一致
          if (localStorage.getItem('onboarding') == res.onboarding.key) {
            next();
          } else {
            sessionStorage.setItem('boardBack', window.location.origin + to.fullPath);
            router.replace({ path: '/onboarding' });
          }
        } else {
          next();
        }
      }, window.location.origin + to.fullPath);
    } else {
      var params = {
        sharetype: 'default'
      };
      api.getShare(params).then(function (res) {
        var sv = res.share;
        sessionStorage.setItem('initData', (0, _stringify2.default)(res));
        _share2.default.baseConfig(sv, function (res) {
          sessionStorage.setItem('noticeUnread', res.notice_unread);
          var s = new Date(res.onboarding.start_time.replace(/-/g, '/')).getTime();
          var e = new Date(res.onboarding.end_time.replace(/-/g, '/')).getTime();
          var n = new Date().getTime();
          if (n > s && n < e && res.onboarding.status == '1') {
            // key一致
            if (localStorage.getItem('onboarding') == res.onboarding.key) {
              next();
            } else {
              sessionStorage.setItem('boardBack', window.location.origin + to.fullPath);
              router.replace({ path: '/onboarding' });
            }
          } else {
            next();
          }
        });
      }, window.location.origin + to.fullPath);
    }
  } else {
    next();
  }
});
// router.beforeEach((to, from, next) => {
//   // 除去特殊分享的页面(一般页面)
//   var shareData = sessionStorage.getItem('initData')
//   if (to.name != 'onboarding' && !to.meta.share) {
//     var onboarding = localStorage.getItem('onboarding')
//     if (onboarding) {
//       next()
//     } else {
//       if (shareData) {
//         shareApi.baseConfig(JSON.parse(shareData).share, function (res) {
//           sessionStorage.setItem('noticeUnread', res.notice_unread)
//           var s = new Date(res.onboarding.start_time.replace(/-/g, '/')).getTime()
//           var e = new Date(res.onboarding.end_time.replace(/-/g, '/')).getTime()
//           var n = new Date().getTime()
//           // 时间一致
//           if (n > s && n < e && res.onboarding.status == '1') {
//             // key一致
//             if (localStorage.getItem('onboarding') == res.onboarding.key) {
//               next()
//             } else {
//               sessionStorage.setItem('boardBack', window.location.origin + to.fullPath)
//               router.replace({path: '/onboarding'})
//             }
//           } else {
//             next()
//           }
//         })
//       } else {
//         var params = {
//           sharetype: 'default'
//         }
//         api.getShare(params).then((res) => {
//           let sv = res.share
//           sessionStorage.setItem('initData', JSON.stringify(res))
//           shareApi.baseConfig(sv, function (res) {
//             sessionStorage.setItem('noticeUnread', res.notice_unread)
//             var s = new Date(res.onboarding.start_time.replace(/-/g, '/')).getTime()
//             var e = new Date(res.onboarding.end_time.replace(/-/g, '/')).getTime()
//             var n = new Date().getTime()
//             if (n > s && n < e && res.onboarding.status == '1') {
//               // key一致
//               if (localStorage.getItem('onboarding') == res.onboarding.key) {
//                 next()
//               } else {
//                 sessionStorage.setItem('boardBack', window.location.origin + to.fullPath)
//                 router.replace({path: '/onboarding'})
//               }
//             } else {
//               next()
//             }
//           })
//         })
//       }
//     }
//   } else {
//   next()
//   }
// })
exports.default = router;

/***/ }),

/***/ "Yd+V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"ly-tab-item",style:(_vm.$parent.value === _vm.id ? _vm.activeStyle : {}),on:{"click":_vm.onItemClicked}},[_c('div',{staticClass:"ly-tab-item-icon"},[_vm._t("icon")],2),_vm._v(" "),_c('div',{staticClass:"ly-tab-item-label"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aK6G":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMomentInfo = exports.getMomentList = exports.getRankInfo = exports.getRankList = exports.getBookInfo = exports.getBook = exports.getPackAge = exports.activeCode = undefined;

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

// 激活码激活课程
var activeCode = exports.activeCode = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(ac, ck) {
    var result;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _vue2.default.prototype.postAxios(_base.base.ACTIVE_CODE, { ac: ac, ck: ck }, { errData: true, isLoading: true });

          case 2:
            result = _context.sent;
            return _context.abrupt('return', result);

          case 4:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function activeCode(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
// 渠道领取


// 获取专栏列表
var getPackAge = exports.getPackAge = function () {
  var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
    var result;
    return _regenerator2.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return _vue2.default.prototype.postAxios(_base.base.PACKAGE_LIST);

          case 2:
            result = _context2.sent;
            return _context2.abrupt('return', result);

          case 4:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function getPackAge() {
    return _ref2.apply(this, arguments);
  };
}();
// 获取专栏详情


// 专栏下的图书列表
var getBook = exports.getBook = function () {
  var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(pid, page, list_rows) {
    var result;
    return _regenerator2.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return _vue2.default.prototype.postAxios(_base.base.BOOK_LIST, { pid: pid, page: page, list_rows: list_rows }, { isLoading: true });

          case 2:
            result = _context3.sent;
            return _context3.abrupt('return', result);

          case 4:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function getBook(_x3, _x4, _x5) {
    return _ref3.apply(this, arguments);
  };
}();
// 图书详情


var getBookInfo = exports.getBookInfo = function () {
  var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(pid, bid) {
    var result;
    return _regenerator2.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return _vue2.default.prototype.postAxios(_base.base.BOOK_INFO, { pid: pid, bid: bid });

          case 2:
            result = _context4.sent;
            return _context4.abrupt('return', result);

          case 4:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, this);
  }));

  return function getBookInfo(_x6, _x7) {
    return _ref4.apply(this, arguments);
  };
}();
// 图书音频播放


// 点赞榜列表
var getRankList = exports.getRankList = function () {
  var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(params) {
    var result;
    return _regenerator2.default.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return _vue2.default.prototype.postAxios(_base.base.RANK_LIST, params);

          case 2:
            result = _context5.sent;
            return _context5.abrupt('return', result);

          case 4:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, this);
  }));

  return function getRankList(_x8) {
    return _ref5.apply(this, arguments);
  };
}();
// 点赞榜基本信息


var getRankInfo = exports.getRankInfo = function () {
  var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(id, pId, year, month) {
    var bid, pid, result;
    return _regenerator2.default.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            bid = id || '';
            pid = pId || '';
            _context6.next = 4;
            return _vue2.default.prototype.postAxios(_base.base.RANK_INFO, { bid: bid, pid: pid, year: year, month: month });

          case 4:
            result = _context6.sent;
            return _context6.abrupt('return', result);

          case 6:
          case 'end':
            return _context6.stop();
        }
      }
    }, _callee6, this);
  }));

  return function getRankInfo(_x9, _x10, _x11, _x12) {
    return _ref6.apply(this, arguments);
  };
}();
// 空间信息


// 获取我的空间列表
var getMomentList = exports.getMomentList = function () {
  var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7(uid, bookId, page) {
    var uls, bid, result;
    return _regenerator2.default.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            uls = uid || '';
            bid = bookId || '';
            _context7.next = 4;
            return _vue2.default.prototype.postAxios(_base.base.MOMENT_LIST, { uls: uls, bid: bid, page: page });

          case 4:
            result = _context7.sent;
            return _context7.abrupt('return', result);

          case 6:
          case 'end':
            return _context7.stop();
        }
      }
    }, _callee7, this);
  }));

  return function getMomentList(_x13, _x14, _x15) {
    return _ref7.apply(this, arguments);
  };
}();
// 获取Moment详情


var getMomentInfo = exports.getMomentInfo = function () {
  var _ref8 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee8(mid, id) {
    var uls, result;
    return _regenerator2.default.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            uls = id || '';
            _context8.next = 3;
            return _vue2.default.prototype.postAxios(_base.base.MOMENT_INFO, { mid: mid, uls: uls }, { errData: true, isLoading: true });

          case 3:
            result = _context8.sent;
            return _context8.abrupt('return', result);

          case 5:
          case 'end':
            return _context8.stop();
        }
      }
    }, _callee8, this);
  }));

  return function getMomentInfo(_x16, _x17) {
    return _ref8.apply(this, arguments);
  };
}();
// 设置动态为公开/私密


exports.init = init;
exports.getJsticket = getJsticket;
exports.getShare = getShare;
exports.activeByChannelKey = activeByChannelKey;
exports.paySuccess = paySuccess;
exports.getQrcode = getQrcode;
exports.sQrcount = sQrcount;
exports.initConfig = initConfig;
exports.packageInfo = packageInfo;
exports.playBook = playBook;
exports.getZoneInfo = getZoneInfo;
exports.setPublic = setPublic;
exports.delMoment = delMoment;
exports.sendMoment = sendMoment;
exports.setLike = setLike;
exports.report = report;
exports.getConfig = getConfig;

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _base = __webpack_require__("Dod7");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
nGv: false - 没有V1、V2版本号
isLoading: true - 显示加载
*/
// 初始化
function init() {
  return _vue2.default.prototype.postAxios(_base.base.INIT);
}
// 获取微信开发列表
function getJsticket(url) {
  return _vue2.default.prototype.postAxios(_base.base.getJSLIST, { url: url });
}
// 获取分享设置
function getShare(params) {
  return _vue2.default.prototype.postAxios(_base.base.GET_SHARE, params);
}function activeByChannelKey(cc, bk, ck) {
  return _vue2.default.prototype.postAxios(_base.base.ACTIVE_BY_CHANNELKEY, { cc: cc, bk: bk, ck: ck });
}
// 购买成功
function paySuccess(order_id) {
  return _vue2.default.prototype.postAxios(_base.base.PAY_SUCCESS, { order_id: order_id });
}
// 获取二维码
function getQrcode(type) {
  return _vue2.default.prototype.postAxios(_base.base.GET_QRCODE, { type: type }, { isLoading: true });
}
// 二维码识别次数
function sQrcount(tag) {
  return _vue2.default.prototype.postAxios(_base.base.S_QRCOUNT, { tag: tag });
}
// 初始化
function initConfig() {
  return _vue2.default.prototype.postAxios(_base.base.INIT_CONFIG);
}function packageInfo(pid) {
  return _vue2.default.prototype.postAxios(_base.base.PACKAGE_INFO, { pid: pid });
}function playBook(pid, bid, baid) {
  return _vue2.default.prototype.postAxios(_base.base.BOOK_PLAY, { pid: pid, bid: bid, baid: baid });
}function getZoneInfo(uls) {
  return _vue2.default.prototype.postAxios(_base.base.ZONE_INFO, { uls: uls });
}function setPublic(mid, isp) {
  return _vue2.default.prototype.postAxios(_base.base.SET_PUBLIC, { mid: mid, isp: isp });
}
// 删除用户动态
function delMoment(mid) {
  return _vue2.default.prototype.postAxios(_base.base.DEL_MOMENT, { mid: mid });
}
// 发布用户动态
function sendMoment(pid, bid, isp, type, media_ids) {
  return _vue2.default.prototype.postAxios(_base.base.SEND_MOMENT, { pid: pid, bid: bid, isp: isp, type: type, media_ids: media_ids });
}
// 点赞用户状态
function setLike(mid) {
  return _vue2.default.prototype.postAxios(_base.base.SET_LIKE, { mid: mid });
}
// 举报
function report(type, rtype, other_str, mid, uls) {
  return _vue2.default.prototype.postAxios(_base.base.REPORT, { type: type, rtype: rtype, other_str: other_str, mid: mid, uls: uls });
}
// 获取配置
function getConfig(params) {
  return _vue2.default.prototype.postAxios(_base.base.GET_CONFIG, params);
}

/***/ }),

/***/ "bDtG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'scroll',
  data: function data() {
    return {
      scrollNum: 0
    };
  },
  mounted: function mounted() {
    this.wScroll(this, this.$refs.scroll);
  },

  methods: {
    // 监听显示右侧悬浮菜单
    scrollBind: function scrollBind() {
      if ($('.scrollWarp')[0]) {
        var scrollObj = $('.scrollWarp')[0].getBoundingClientRect();
        this.scrollNum = scrollObj.top;
        if (this.scrollNum <= -250) {
          this.$emit('showTop', true);
        } else {
          this.$emit('showTop', false);
        }
      }
    },

    // 监听滑动
    wScroll: function wScroll(that, elem) {
      var startX = 0;
      var startY = 0;
      document.addEventListener('touchstart', function (evt) {
        var touch = evt.touches[0];
        startX = Number(touch.pageX);
        startY = Number(touch.pageY);
      });
      elem.addEventListener('touchmove', function (ev) {
        var moveEndX = ev.touches[0].pageX;
        var moveEndY = ev.touches[0].pageY;
        var X = moveEndX - startX;
        var Y = moveEndY - startY;
        // 由左向右
        if (Math.abs(X) > Math.abs(Y) && X > 0) {
          return false;
        } else if (Math.abs(X) > Math.abs(Y) && X < 0) {
          // 由右向左
          return false;
        } else {
          if (Math.abs(Y) > Math.abs(X) && Y > 0) {
            that.$emit('animation', false, Y, ev);
          } else if (Math.abs(Y) > Math.abs(X) && Y < 0) {
            that.$emit('animation', true, Y, ev);
          }
          var _point = ev.touches[0];
          // var _top = parseInt(elem.scrollTop)
          var _top = elem.scrollTop;
          var _bottomFaVal = elem.scrollHeight - elem.offsetHeight;
          if (_top > 250 || that.scrollNum <= -250) {
            that.$emit('showTop', true);
          } else {
            that.$emit('showTop', false);
          }
          if (_top === 0) {
            if (_point.clientY > startY && ev.cancelable) {
              ev.preventDefault();
            } else if (_bottomFaVal == 0) {
              ev.preventDefault();
            } else {
              ev.stopPropagation();
            }
          } else if (_top === _bottomFaVal) {
            if (_point.clientY < startY) {
              elem.scrollTop--;
            } else {
              ev.stopPropagation();
            }
          } else if (_top > 0 && _top < _bottomFaVal) {
            ev.stopPropagation();
          } else {
            ev.preventDefault();
          }
        }
      }, { passive: false });
    },
    goTop: function goTop() {
      this.$refs.scroll.scrollTop = 0;
      this.$emit('showTop', false);
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "dPNW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eXeN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eh36":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fJZj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fc2l":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "g3Gj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gF8e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"better",attrs:{"id":"qy"}},[(_vm.isRouterAlive)?_c('router-view'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hW8u":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nsZj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pxwZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toast = __webpack_require__("/QYm");

var _toast2 = _interopRequireDefault(_toast);

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

__webpack_require__("eqfM");

var _vant = __webpack_require__("Fd2+");

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

var _qs = __webpack_require__("mw3O");

var _qs2 = _interopRequireDefault(_qs);

var _common = __webpack_require__("2Uyi");

var _common2 = _interopRequireDefault(_common);

var _config = __webpack_require__("T452");

var _index = __webpack_require__("YaEn");

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 接口状态

// 在config.js文件中统一存放一些公共常量，方便之后维护
var apiStatus = _config.config.status;
// Login-Type   1：微信公众号授权；2：微信小程序授权；3：微信开放平台APP授权；4：手机号登录；5:web
// Client-Type  1：H5（1）；2：小程序（2）；3：APP（登录方式（Login-Type：3、4））；4:web
// 每种客户端有一种或多种登录类型，Login-Type为动态值
var AjaxHeader = {
  'Content-Type': 'application/x-www-form-urlencoded',
  'Login-Type': 1,
  'Client-Type': 1
  // 添加请求拦截器
};_axios2.default.interceptors.request.use(function (config) {
  return config;
}, function (error) {
  // 请求错误时弹框提示
  return _promise2.default.reject(error);
});
// 添加响应拦截器
_axios2.default.interceptors.response.use(function (response) {
  // 如果只需要返回体中数据，则如下，如果需要全部，则 return response 即可
  return response.data;
}, function (error) {
  return _promise2.default.reject(error);
});
// 封装数据返回失败提示函数
function errorState(response) {
  // 如果http状态码正常，则直接返回数据
  if (response.response && response.response.status === 200) {
    // 如果不需要除了data之外的数据，可以直接 return response.data
    return response;
  } else {
    switch (response.request.status) {
      // switch (response.response.status) {
      case 0:
        break;
      case 400:
        (0, _toast2.default)('错误请求');
        break;
      case 401:
        (0, _toast2.default)('未授权，请重新登录');
        break;
      case 403:
        (0, _toast2.default)('拒绝访问');
        break;
      case 404:
        (0, _toast2.default)('请求错误，未找到该资源');
        break;
      case 405:
        (0, _toast2.default)('请求方法为允许');
        break;
      case 408:
        (0, _toast2.default)('请求超时');
        break;
      case 500:
        (0, _toast2.default)('服务器端出错');
        break;
      case 501:
        (0, _toast2.default)('网络未实现');
        break;
      case 502:
        (0, _toast2.default)('网络错误');
        break;
      case 503:
        (0, _toast2.default)('服务不可用');
        break;
      case 504:
        (0, _toast2.default)('网络超时');
        break;
      case 505:
        (0, _toast2.default)('http版本不支持该请求');
        break;
      default:
        (0, _toast2.default)('网络出现问题，请稍后再试');
    }
  }
}
// 封装axios
function apiAxios(method, url, params, config) {
  // 加载
  if (config && config.isLoading == true) {
    _toast2.default.loading({
      message: '加载中...',
      forbidClick: true
    });
  }
  // nGv - false 没有版本号
  var URL = void 0;
  if (config && config.nGv == false) {
    URL = _common2.default.URLProxy(url);
  } else {
    URL = _common2.default.URLProxy(url, _common2.default.GV);
  }
  // var paramsObj = {}
  // paramsObj.hebzh = 10
  // var newObj = Object.assign(paramsObj, params)
  var httpDefault = {
    method: method,
    baseURL: _common2.default.GRoot,
    url: URL,
    params: method === 'GET' || method === 'DELETE' ? params : null,
    data: method === 'POST' || method === 'PUT' ? _qs2.default.stringify(params, { indices: false }) : null,
    timeout: 6000,
    headers: AjaxHeader,
    emulateJSON: true
  };
  return new _promise2.default(function (resolve, reject) {
    (0, _axios2.default)(httpDefault).then(function (res) {
      // 清除加载提示
      if (res) {
        _toast2.default.clear();
      }
      // 统一判断后端返回的错误码
      if (res.code == 10001) {
        // 未登录
        _common2.default.ckLogin(res.is_login);
      } else if (res.code === -888) {
        // -888 如果是init接口返回数据  其他返回base页面
        if (url == _common2.default.initUrl) {
          return resolve(res);
        } else {
          _index2.default.replace({ name: 'base' });
        }
      } else if (res.code === 10000) {
        // 请求成功返回数据
        return resolve(res.data);
      } else if (res.code === -999) {
        // -999 错误提示
        (0, _toast2.default)({
          message: res.message,
          duration: 60000
        });
      } else if (apiStatus[res.code]) {
        // 接口错误提示
        (0, _toast2.default)(apiStatus[res.code]);
      } else {
        if (config && config.nGv == false || config && config.errData == true) {
          return resolve(res);
        } else {
          (0, _toast2.default)(res.message);
        }
      }
    }).catch(function (response) {
      reject(response);
      errorState(response);
    });
  });
}
exports.default = {
  install: function install(Vue) {
    Vue.prototype.getAxios = function (url, params, config) {
      return apiAxios('GET', url, params, config);
    };
    Vue.prototype.postAxios = function (url, params, config) {
      return apiAxios('POST', url, params, config);
    };
    Vue.prototype.putAxios = function (url, params, config) {
      return apiAxios('PUT', url, params, config);
    };
    Vue.prototype.delectAxios = function (url, params, config) {
      return apiAxios('DELECT', url, params, config);
    };
  }
};

/***/ }),

/***/ "r/Ju":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _vconsole = __webpack_require__("Lw6n");

var _vconsole2 = _interopRequireDefault(_vconsole);

var _common = __webpack_require__("2Uyi");

var _common2 = _interopRequireDefault(_common);

var _book = __webpack_require__("aK6G");

var api = _interopRequireWildcard(_book);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var jsList;
exports.default = {
	isWeixin: isWeixin,
	baseConfig: baseConfig,
	wxShareInfo: wxShareInfo,
	vconsoleStatus: vconsoleStatus
	// 判断是否是微信浏览器
};
function isWeixin() {
	var ua = window.navigator.userAgent.toLowerCase();
	if (ua.match(/MicroMessenger/i) == 'micromessenger') {
		return true;
	} else {
		return false;
	}
}
function baseConfig(params, callback, urlPath) {
	// 权限接口
	var url;
	if (urlPath) {
		url = urlPath;
	} else {
		url = window.location.href;
	}
	api.getJsticket(url).then(function (res) {
		var wxConfig = res.wxjssdk;
		jsList = wxConfig.jsApiList;
		wx.config({
			// debug: true,
			appId: wxConfig.appId,
			timestamp: wxConfig.timestamp,
			nonceStr: wxConfig.nonceStr,
			signature: wxConfig.signature,
			jsApiList: wxConfig.jsApiList
		});
		wxShareInfo(params, res);
		callback && callback(res);
		vconsoleStatus(res);
	});
}
function wxShareInfo(obj, user) {
	var opt = obj || {};
	var links = opt.link || _common2.default.Root + 'home';
	var title = opt.title || 'Better更好学苑';
	var desc = opt.desc || 'Be Better , Be Yourself .突破家庭与命运，重塑性格、情绪、关系，重获安全感，成为内心强大自由坚定的更好自己。';
	var imgUrl = opt.imgUrl || _common2.default.Root + 'static/images/icons/share.png';
	var hideMenu = ['menuItem:copyUrl', 'menuItem:share:qq', 'menuItem:share:weiboApp', 'menuItem:share:facebook', 'menuItem:share:QZone', 'menuItem:editTag', 'menuItem:delete', 'menuItem:originPage', 'menuItem:readMode', 'menuItem:openWithQQBrowser', 'menuItem:openWithSafari', 'menuItem:share:email', 'menuItem:share:brand'];
	var devUser = user.dev_user == 1 ? [] : hideMenu;
	wx.ready(function () {
		wx.checkJsApi({
			jsApiList: jsList,
			success: function success(res) {
				if (res) {
					console.log('title', title);
					console.log('desc', desc);
					console.log('imgUrl', imgUrl);
					wx.hideMenuItems({
						menuList: devUser
					});
					wx.onMenuShareAppMessage({
						title: title,
						desc: desc,
						link: links,
						imgUrl: imgUrl,
						success: function success(v) {
							console.log('分享成功', v);
						},
						fail: function fail(e) {
							console.log('分享错误', e);
						},
						cancel: function cancel() {
							// 用户取消分享后执行的回调函数
							console.log('用户取消分享后执行的回调函数');
						}
					});
					wx.onMenuShareTimeline({
						title: title,
						desc: desc,
						link: links,
						imgUrl: imgUrl,
						success: function success(v) {}
					});
				}
			}
		});
	});
}
function vconsoleStatus(obj) {
	if (obj.dev_user === 1) {
		var vConsole = new _vconsole2.default();
		_vue2.default.use(vConsole);
	}
}

/***/ }),

/***/ "uVdW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uZYF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/**
 * ly-tab-item
 * @desc 搭配 tab 使用
 * @param {Number} id - 选中的item的索引值
 * @param {slot} [icon] - icon 图标
 * @param {slot} - 文字
 *
 * @example
 * <ly-tab-item>
 *   <img slot="icon" src="http://placehold.it/100x100">
 *   前端
 * </ly-tab-item>
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LyTabItem',
  computed: {
    activeStyle: function activeStyle() {
      return {
        color: this.$parent.activeColor,
        borderColor: this.$parent.activeColor,
        borderWidth: this.$parent.lineWidth,
        borderBottomStyle: 'solid'
      };
    }
  },
  data: function data() {
    return {
      id: (this.$parent.$children.length || 1) - 1
    };
  },

  methods: {
    onItemClicked: function onItemClicked() {
      this.$parent.$emit('input', this.id);
    }
  }
});

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-in": "yJfC",
	"./en-in.js": "yJfC",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./en-sg": "NYST",
	"./en-sg.js": "NYST",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fil": "rMbQ",
	"./fil.js": "rMbQ",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-deva": "VGQH",
	"./gom-deva.js": "VGQH",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./oc-lnc": "KOFO",
	"./oc-lnc.js": "KOFO",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-mo": "+WA1",
	"./zh-mo.js": "+WA1",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "vMJZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUserInfo = getUserInfo;
exports.editUserInfo = editUserInfo;
exports.ckMobile = ckMobile;
exports.sendCode = sendCode;
exports.bindMobile = bindMobile;
exports.accountInfo = accountInfo;
exports.getTradeRecord = getTradeRecord;
exports.getTradeRecordInfo = getTradeRecordInfo;
exports.getWithDraw = getWithDraw;
exports.withDrawApply = withDrawApply;
exports.withDrawInfo = withDrawInfo;
exports.withDrawTax = withDrawTax;
exports.realNameAuth = realNameAuth;
exports.realNameAuthInfo = realNameAuthInfo;
exports.feedBack = feedBack;
exports.feedBackInfo = feedBackInfo;
exports.creatFeedBack = creatFeedBack;
exports.delFeedBack = delFeedBack;
exports.getNotice = getNotice;
exports.noticeRead = noticeRead;
exports.noticeUnread = noticeUnread;
exports.noticeDel = noticeDel;
exports.calendarList = calendarList;
exports.checkInStatus = checkInStatus;
exports.checkIn = checkIn;
exports.diaryList = diaryList;
exports.diaryInfo = diaryInfo;
exports.editDiary = editDiary;
exports.delDiary = delDiary;

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _base = __webpack_require__("Dod7");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 获取用户信息
function getUserInfo() {
  return _vue2.default.prototype.postAxios(_base.base.USER_INFO);
}
// 编辑用户信息
function editUserInfo(param) {
  return _vue2.default.prototype.postAxios(_base.base.EDIT_USER, param);
}
// 检查手机绑定状态
function ckMobile() {
  return _vue2.default.prototype.postAxios(_base.base.CHECK_MOBILE);
}
// 发送验证码
function sendCode(m, t) {
  return _vue2.default.prototype.postAxios(_base.base.SEND_CODE, { m: m, t: t });
}
// 绑定手机号
function bindMobile(m, c, t) {
  return _vue2.default.prototype.postAxios(_base.base.BIND_MOBILE, { m: m, c: c, t: t });
}
// 用户账户信息
function accountInfo() {
  return _vue2.default.prototype.postAxios(_base.base.ACCOUNT_INFO);
}
// 交易记录
function getTradeRecord() {
  return _vue2.default.prototype.postAxios(_base.base.TRADE_RECORD);
}
// 交易记录详情
function getTradeRecordInfo(trid) {
  return _vue2.default.prototype.postAxios(_base.base.TRADE_RECORD_INFO, { trid: trid });
}
// 提现记录
function getWithDraw(page, list_rows) {
  return _vue2.default.prototype.postAxios(_base.base.WITH_DRAW, { page: page, list_rows: list_rows });
}
// 提现申请
function withDrawApply(a_amt) {
  return _vue2.default.prototype.postAxios(_base.base.WITH_DRAW_APPLY, { a_amt: a_amt });
}
// 提现详情
function withDrawInfo(wid) {
  return _vue2.default.prototype.postAxios(_base.base.WITH_DRAW_INFO, { wid: wid });
}
// 税金计算
function withDrawTax(a_amt) {
  return _vue2.default.prototype.postAxios(_base.base.WITH_DRAW_TAX, { a_amt: a_amt });
}
// 实名认证
function realNameAuth(realname, IDCardNumber, tag) {
  return _vue2.default.prototype.postAxios(_base.base.REALNAME_AUTH, { realname: realname, IDCardNumber: IDCardNumber, tag: tag });
}
// 实名认证信息
function realNameAuthInfo() {
  return _vue2.default.prototype.postAxios(_base.base.REALNAME_AUTH_INFO);
}
// 获取意见反馈
function feedBack(page, list_rows) {
  return _vue2.default.prototype.postAxios(_base.base.FEED_BACK, { page: page, list_rows: list_rows });
}
// 意见反馈详情
function feedBackInfo(fbid) {
  return _vue2.default.prototype.postAxios(_base.base.FEED_BACK_INFO, { fbid: fbid });
}
// 新增意见反馈
function creatFeedBack(type, content, contacts) {
  return _vue2.default.prototype.postAxios(_base.base.ADD_FEED_BACK, { type: type, content: content, contacts: contacts });
}
// 删除意见反馈
function delFeedBack(fbid) {
  return _vue2.default.prototype.postAxios(_base.base.DEL_FEED_BACK, { fbid: fbid });
}
// 获取通知消息列表
function getNotice(page, list_rows) {
  return _vue2.default.prototype.postAxios(_base.base.NOTICE_LIST, { page: page, list_rows: list_rows });
}
// 设置通知消息已读
function noticeRead(all, nmid) {
  return _vue2.default.prototype.postAxios(_base.base.NOTICE_READ, { all: all, nmid: nmid });
}
// 获取通知消息未读的数量
function noticeUnread() {
  return _vue2.default.prototype.postAxios(_base.base.NOTICE_UNREAD_COUNT);
}
// 删除通知消息
function noticeDel(params) {
  return _vue2.default.prototype.postAxios(_base.base.NOTICE_DEL, params);
}
// 日历列表
function calendarList(params) {
  return _vue2.default.prototype.postAxios(_base.base.CALENDAR_LIST, params);
}
// 检查今日打卡状态
function checkInStatus(params) {
  return _vue2.default.prototype.postAxios(_base.base.CHECK_IN_STATUS, params);
}
// 签到打卡
function checkIn(params) {
  return _vue2.default.prototype.postAxios(_base.base.CHECK_IN, params);
}
// 获取用户日记列表
function diaryList(page, list_rows) {
  return _vue2.default.prototype.postAxios(_base.base.DIARY_LIST, { page: page, list_rows: list_rows });
}
// 获取用户日历详情
function diaryInfo(did) {
  return _vue2.default.prototype.postAxios(_base.base.DIARY_INFO, { did: did });
}
// 新增、编辑日记
function editDiary(params) {
  return _vue2.default.prototype.postAxios(_base.base.DIARY_EDIT, params);
}
// 删除日记
function delDiary(did) {
  return _vue2.default.prototype.postAxios(_base.base.DIARY_DEL, { did: did });
}

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_book_js__ = __webpack_require__("aK6G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_book_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__api_book_js__);

//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  provide: function provide() {
    return {
      reload: this.reload
    };
  },
  data: function data() {
    return {
      isRouterAlive: true,
      transitionName: ''
    };
  },

  watch: {
    $route: function $route(to, from) {
      if (to.name != 'onboarding' && !to.meta.share) {
        // this.getShare()
      }
    }
  },
  destroyed: function destroyed() {
    window.removeEventListener('popstate', this.goBack, false);
  },
  mounted: function mounted() {
    if (sessionStorage.getItem('playLocalId')) {
      this.endPlay(sessionStorage.getItem('playLocalId'));
    }
    // 拦截后退
    if (window.history && window.history.pushState) {
      window.addEventListener('popstate', this.goBack, false);
    }
  },

  methods: {
    // 停止播放
    endPlay: function endPlay(id) {
      wx.stopVoice({ localId: id });
      sessionStorage.removeItem('playLocalId');
    },
    getShare: function getShare() {
      var _this = this;

      var shareData = sessionStorage.getItem('initData');
      if (shareData) {
        this.wxshare(JSON.parse(shareData).share);
      } else {
        var params = {
          sharetype: 'default'
        };
        __WEBPACK_IMPORTED_MODULE_1__api_book_js__["getShare"](params).then(function (res) {
          var sv = res.share;
          sessionStorage.setItem('initData', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res));
          _this.wxshare(sv);
        });
      }
    },
    wxshare: function wxshare(sv) {
      // 微信分享
      if (this.$wxShare.isWeixin()) {
        this.$wxShare.baseConfig({
          title: sv.title,
          desc: sv.desc,
          imgUrl: sv.imgUrl
        });
      }
    },
    goBack: function goBack() {
      self.location.reload();
    },
    reload: function reload() {
      var _that = this;
      this.isRouterAlive = false;
      this.$nextTick(function () {
        _that.isRouterAlive = true;
      });
    }
  }
});

/***/ }),

/***/ "zNJb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7147a418_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_gradients_vue__ = __webpack_require__("9aVN");
function injectStyle (ssrContext) {
  __webpack_require__("eXeN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7147a418"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7147a418_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_gradients_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.a1a9d6e88179ef989cc8.js